import type { ArReceiptWithAllocations } from '@dcc-erp/shared';
import { fmt, fmtDate, toNumber } from '@dcc-erp/shared';

// Router-free AR receipts list. The route owns data fetching (useArReceipts) +
// loading/error/empty handling; this component owns presentation only — a flat
// table of RV vouchers. Plain prototype.css classes only.

export interface ReceiptsListProps {
  receipts: ArReceiptWithAllocations[];
}

export function ReceiptsList({ receipts }: ReceiptsListProps) {
  return (
    <div className="tbl-shell">
      <div className="tbl-wrap" style={{ maxHeight: 600 }}>
        <table className="tbl">
          <thead>
            <tr>
              <th>เลขที่ใบรับชำระ</th>
              <th>วันที่รับชำระ</th>
              <th>ลูกค้า</th>
              <th>บัญชีเงินสด / ธนาคาร</th>
              <th className="num">จำนวนเงิน</th>
              <th className="num">จำนวนรายการ</th>
            </tr>
          </thead>
          <tbody>
            {receipts.length === 0 ? (
              <tr>
                <td colSpan={6} className="muted" style={{ textAlign: 'center', padding: 20 }}>
                  ไม่มีข้อมูล
                </td>
              </tr>
            ) : (
              receipts.map((rv) => (
                <tr key={rv.id}>
                  <td>
                    <span className="code">{rv.voucherNo}</span>
                  </td>
                  <td>{fmtDate(rv.receiptDate)}</td>
                  <td>{rv.customerName}</td>
                  <td>{rv.cashAccountCode}</td>
                  <td className="num tnum">{fmt(toNumber(rv.totalAmount), 2)}</td>
                  <td className="num tnum">{rv.allocations.length}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
